// extracted by mini-css-extract-plugin
export default {"colorBox":"colorBox__k1rcmB","defaultColorWrapper":"defaultColorWrapper__I7vyES","defaultColorText":"defaultColorText__eZDjK7"};